import {useQuery} from '@tanstack/react-query';
import {api,client} from '../lib/api';
import {DRAFT_ATTENTION_HOURS,unreviewedDrafts} from '../lib/communication-summary';
import {useCases} from './useCases';
import {useFollowUps,useLeads,useMaterialsAtRisk} from './useReads';
/** The badge and destination deliberately share the same sources and filters. */
export function useAttention(){
 const approvals=useCases(),leads=useLeads({location:'attention'}),risks=useMaterialsAtRisk(),tasks=useFollowUps();
 const messages=useDeskDrafts();
 const prepared=unreviewedDrafts(messages.data??[],approvals.open);
 // The first page of the due-ordered queue holds the oldest overdue tasks; the count is the whole queue's.
 const overdue=(tasks.data?.data??[]).filter(f=>Date.parse(String(f.due))<Date.now());
 const overdueCount=Math.max(tasks.data?.overdue_count??0,overdue.length);
 return {messages,prepared,approvals,leads,risks,tasks,overdue,overdueCount,count:prepared.length+approvals.open.length+(leads.data?.length??0)+(risks.data?.length??0)+overdueCount};
}

/** Fresh saved drafts only — the drawer and Immediate attention need nothing older than DRAFT_ATTENTION_HOURS.
 *  They used to poll the whole communication table every 30 s and throw almost all of it away (13 Oct 2026). */
export function useDeskDrafts(){
 return useQuery({queryKey:['desk-communications'],refetchInterval:30000,queryFn:()=>api.communications(client,{state:'draft',since:new Date(Date.now()-DRAFT_ATTENTION_HOURS*3600_000).toISOString()})});
}
